import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000170FindRequest = Partial<{
  shireCdFrom: string;
  shireCdTo: string;
  name: string;
  kana: string;
  torihikisakibun: string;
  shirebunCd: string;
  deljogaiKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000170FindResponse = {
  shireCd: string;
  shainCd: string;
  shireNm1: string;
  shireNm2: string;
  shireNmr: string;
  shireKana: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shokuchiKbn: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  shirebunCd1: string;
  shirebunCd2: string;
  shirebunCd3: string;
  shirebunCd4: string;
  shirebunCd5: string;
  sakujoyoteiKbn: string;
  version: string;
};

export const B000170Find = (props: B000170FindRequest) => {
  return RestClient.get<PageableResponse<B000170FindResponse[]>>(
    "b000170/find",
    {
      params: props,
    }
  );
};

export type B000170GetRequest = {
  shireCd: string;
};

export const B000170Get = (props: B000170GetRequest) => {
  return RestClient.get("b000170/get", {
    params: props,
  });
};

//仕入先名表示(コンポーネントはshireNmr)
export const B000170ShireNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shireCd === "") {
    methods.setValue("shireNmr", data.shireCd);
    return;
  }
  await B000170Get({ shireCd: data.shireCd })
    .then((response) => {
      methods.setValue("shireNmr", response.data.shireNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shireNmr", "");
    });
};

//仕入先名表示(コンポーネントはshireNm)
export const B000170ShireNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shireCd === "") {
    methods.setValue("shireNm", data.shireCd);
    return;
  }
  await B000170Get({ shireCd: data.shireCd })
    .then((response) => {
      methods.setValue("shireNm", response.data.shireNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shireNm", "");
    });
};

//仕入先名表示(コンポーネントはshireNm),shireShokuchiKbnにセット
export const B000170ShireNmShokuchi = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shireCd === "") {
    methods.setValue("shireNm", "");
    methods.setValue("shireShokuchiKbn", "");
    return;
  }
  await B000170Get({ shireCd: data.shireCd })
    .then((response) => {
      methods.setValue("shireNm", response.data.shireNmr ?? "");
      methods.setValue("shireShokuchiKbn", response.data.shokuchiKbn ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shireNm", "");
      methods.setValue("shireShokuchiKbn", "");
    });
};

//お届け先名表示(コンポーネントはotodokeNm),otodokeShokuchiKbnにセット
export const B000170OtodokeNmShokuchi = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.otodokeCd === "") {
    methods.setValue("otodokeNm", "");
    methods.setValue("otodokeShokuchiKbn", "");
    return;
  }
  await B000170Get({ shireCd: data.otodokeCd })
    .then((response) => {
      methods.setValue("otodokeNm", response.data.shireNmr ?? "");
      methods.setValue("otodokeShokuchiKbn", response.data.shokuchiKbn ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("otodokeNm", "");
      methods.setValue("otodokeShokuchiKbn", "");
    });
};
